const generateSrcset = (image, widths = []) => {
	const imageUrl = new URL(image["src"]);
	return widths
		.filter((width) => width <= image["width"])
		.map((width) => {
			imageUrl.searchParams.set("width", width.toString());
			return `${imageUrl.href} ${width}w`;
		})
		.join(", ");
};

const createImageElement = (image, classes, sizes, productTitle) => {
	const previewImage = image["preview_image"];
	const newImage = new Image(previewImage["width"], previewImage["height"]);
	newImage.className = classes;
	newImage.alt = image["alt"] || productTitle;
	newImage.sizes = sizes;
	newImage.src = previewImage["src"];
	newImage.srcset = generateSrcset(
		previewImage,
		[165, 360, 533, 720, 940, 1066]
	);
	newImage.loading = "lazy";
	return newImage;
};

const checkSwatches = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		wrapper.querySelectorAll(".js-color-swatches input").forEach((input) => {
			input.addEventListener("click", (event) => {
				const primaryImage = wrapper.querySelector(".media--first");
				const secondaryImage = wrapper.querySelector(".media--second");
				const handleProduct = wrapper.dataset.product;

				if (event.currentTarget.checked && primaryImage) {
					wrapper
						.querySelector(".js-color-swatches-link")
						.setAttribute("href", event.currentTarget.dataset.variantLink);
					const currentColor = event.currentTarget.value;

					jQuery.getJSON(
						window.Shopify.routes.root + `products/${handleProduct}.js`,
						function (product) {
							const variant = product.variants.filter(
								(item) =>
									item.featured_media != null &&
									item.options.includes(currentColor)
							)[0];
							if (variant) {
								const newPrimaryImage = createImageElement(
									variant["featured_media"],
									primaryImage.className,
									primaryImage.sizes,
									product.title
								);

								if (newPrimaryImage.src !== primaryImage.src) {
									let flag = false;
									if (secondaryImage) {
										const secondaryImagePathname = new URL(secondaryImage.src).pathname;
										const newPrimaryImagePathname = new URL(newPrimaryImage.src).pathname;

										if (secondaryImagePathname == newPrimaryImagePathname) {
											primaryImage.remove();
											secondaryImage.classList.remove("media--second");
											secondaryImage.classList.add("media--first");
											flag = true;
										}
									}
									if (flag == false) {
										primaryImage.animate(
											{ opacity: [1, 0] },
											{ duration: 200, easing: "ease-in", fill: "forwards" }
										).finished;
										setTimeout(function () {
											primaryImage.replaceWith(newPrimaryImage);
											newPrimaryImage.animate(
												{ opacity: [0, 1] },
												{ duration: 200, easing: "ease-in" }
											);
											if (secondaryImage) {
												secondaryImage.remove();
											}
										}, 200);
									}
								}
							}
						}
					);
				}
			});
		});
	});
};

/* === Swatch HOVER preview (added) ===
 * Hovering a color swatch temporarily shows that color's variant image on the
 * product card by swapping the source of the hover image (.media--second when
 * present, otherwise .media--first). Moving the mouse away restores the
 * original source, so the normal "hover image -> 2nd photo" behaviour stays
 * intact. Non-destructive: the existing click behaviour above is untouched.
 */
const checkSwatchesHover = () => {
	document.querySelectorAll(".js-color-swatches-wrapper").forEach((wrapper) => {
		if (wrapper.dataset.hoverPreviewInit === "true") return;
		const swatchGroup = wrapper.querySelector(".js-color-swatches");
		if (!swatchGroup) return;
		wrapper.dataset.hoverPreviewInit = "true";

		const handleProduct = wrapper.dataset.product;
		let productData = null;

		// Prefer the hover (second) image so we don't fight the theme's
		// built-in "show 2nd image on hover" effect; fall back to the first.
		const getTarget = () =>
			wrapper.querySelector(".media--second") ||
			wrapper.querySelector(".media--first");

		const restore = () => {
			const img = getTarget();
			if (img && img.dataset.swatchOrigSrc) {
				img.src = img.dataset.swatchOrigSrc;
				img.srcset = img.dataset.swatchOrigSrcset || "";
				delete img.dataset.swatchOrigSrc;
				delete img.dataset.swatchOrigSrcset;
			}
		};

		const preview = (colorValue) => {
			const apply = (product) => {
				const variant = product.variants.filter(
					(item) =>
						item.featured_media != null &&
						item.options.includes(colorValue)
				)[0];
				if (!variant) return;
				const img = getTarget();
				if (!img) return;
				const previewImage = variant.featured_media.preview_image;
				if (!img.dataset.swatchOrigSrc) {
					img.dataset.swatchOrigSrc = img.src;
					img.dataset.swatchOrigSrcset = img.srcset || "";
				}
				img.src = previewImage.src;
				img.srcset = generateSrcset(
					previewImage,
					[165, 360, 533, 720, 940, 1066]
				);
			};

			if (productData) {
				apply(productData);
			} else {
				jQuery.getJSON(
					window.Shopify.routes.root + `products/${handleProduct}.js`,
					function (product) {
						productData = product;
						apply(product);
					}
				);
			}
		};

		swatchGroup.querySelectorAll("input").forEach((input) => {
			const label = swatchGroup.querySelector(`label[for="${input.id}"]`);
			const target = label || input;
			target.addEventListener("mouseenter", () => preview(input.value));
		});

		swatchGroup.addEventListener("mouseleave", restore);
	});
};

function colorSwatches() {
	checkSwatches();
	checkSwatchesHover();

	document.addEventListener("shopify:section:load", function () {
		checkSwatches();
		checkSwatchesHover();
	});
}

(function () {
	colorSwatches();
})();
